"use strict";var p=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var i=(a,r,t,n)=>{for(var e=n>1?void 0:n?u(r,t):r,l=a.length-1,o;l>=0;l--)(o=a[l])&&(e=(n?o(r,t,e):o(e))||e);return n&&e&&p(r,t,e),e};import{baseStyles as d,CiscoUElement as v,html as s,nothing as h}from"@cisco-u/base";import"@cisco-u/stickers/cu-stickers.js";import"@cisco-u/icons/icons/cu-icon-line-right.js";import{property as c,state as m}from"@cisco-u/base/src/decorators.js";import y from"./icon-launch.css.js";export class IconLaunch extends v{static get styles(){return[d,y]}render(){return s`
      ${this.link?s`<a
            href=${this.link}
            class="link-nostyl"
            target=${this._newTab()}
          >
            ${this._returnBody()}
          </a>`:s`<button class="btn-nostyl" @click=${this._dispatchArrowClick}>
            ${this._returnBody()}
          </button>`}
    `}_newTab(){return this.newTab?"_blank":h}_returnBody(){return s`
      <div class="body">
        ${this._returnSticker()}
        <div class="info">
          <h3 class="heading">
            <slot name="heading" @slotchange=${this._setLaunchTitle}></slot>
          </h3>
          <div class="description"><slot name="description"></slot></div>
        </div>
        <span class="arrow-wrapper">
          <cu-icon-line-right size="m"></cu-icon-line-right>
        </span>
      </div>
    `}_returnSticker(){return this.sticker?s`<div class="sticker"><slot name="sticker"></slot></div>`:h}_setLaunchTitle(t){t.target&&(this._launchTitle=t.target.assignedElements({flatten:!0})[0].textContent.trim())}_returnLaunchObject(){return{title:this._launchTitle}}_dispatchArrowClick(t){this.dispatchEvent(new CustomEvent("cu-icon-launch",{detail:{data:this._returnLaunchObject(),event:t}}))}}i([c({type:String,reflect:!0})],IconLaunch.prototype,"link",2),i([c({type:Boolean,reflect:!0})],IconLaunch.prototype,"sticker",2),i([c({type:Boolean,reflect:!0})],IconLaunch.prototype,"newTab",2),i([m()],IconLaunch.prototype,"_launchTitle",2);
//# sourceMappingURL=IconLaunch.js.map
